import React from "react";
import Banner from "../../../components/Banner";
import AccountSettings from "../../../components/AccountSettings";
import Header from "../../../components/Header";
import Bottombar from "../../../components/Bottombar";
import Topbar from "../../../components/Topbar";
import { PAYMENTS } from "../../../constants/settingsStrings.js";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";
function PaymentContMaterCard() {
  return (
    <div className=" overflow-hidden  dark:bg-white dark:text-black dark:h-screen">
      <Topbar />
      <div className="md:block hidden">
        <Header />
      </div>
      <div className="sm:hidden flex space-x-[100px]  mt-7 ">
        <Link to="/settings/paymentContinue">
          <ArrowLeftIcon color="#545454" className="ml-4 w-[17px] h-[17px]" />
        </Link>

        <h3 className="dark:text-black font-bold">Payment Method</h3>
      </div>
      <div className="mt-5 sm:hidden">
        <div class="flex justify-between ">
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center">
              <span class="text-sm font-bold text-white">✓</span>
            </div>
            <div class="mt-2 text-[16px] font-sans font-bold dark:text-black">
              Details
            </div>
          </div>
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center pt-1">
              <span class="text-sm font-bold text-white">✓</span>
            </div>
            <div class="mt-2 text-[16px] font-sans font-bold dark:text-black">
              Payment
            </div>
          </div>
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center pt-2">
              <span class="text-sm font-bold text-white">{}</span>
            </div>
            <div class="mt-2 text-[16px] font-sans font-bold dark:text-black">
              Confirm
            </div>
            {/* <div className="absolute border-2 w-[119px] border-[#6200EE] top-[123px] left-[70px] mn-2"></div>
            <div className="absolute border-2 w-[117px] border-[#EEEEEE] top-[123px] left-[202px] mn-2"></div> */}
          </div>
        </div>
      </div>
      <div className="flex">
        <div className="hidden md:block">
          <AccountSettings active={PAYMENTS} />
        </div>
        <div className="w-full sm:w-[64vw] sm:mx-10 mt-2 h-[70vh] rounded-[15px] sm:shadow-xl my-10">
          <div className="hidden  md:block">
            <Banner />
          </div>

          <div className="hidden md:block mt-3">
            <div className="grid place-content-center ">
              <div className=" flex ">
                <div class=" flex space-x-10 ">
                  <div class="w-1/3 text-center mr-3">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3">
                        ✓
                      </span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Details
                    </div>{" "}
                  </div>
                  <div class="w-1/3 text-center">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3">
                        ✓
                      </span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Payment
                    </div>
                  </div>
                  <div class="w-1/3 text-center ml-3 ">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center pt-6">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3 "></span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Confirm
                    </div>
                    {/* <div className="absolute border-2 w-[78px] border-[#EEEEEE] top-[358px] left-[735px] mn-2"></div>

                    <div className="absolute border-2 w-[70px] border-[#EEEEEE] top-[358px] left-[836px] mn-2"></div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="justify-between sm:flex sm:px-10 m-7   sm:py-8  sm:m-0 space-y-7 sm:space-y-0">
            <img
              src={require("../../../assets/img/mastercardimage.png")}
              alt=""
              className="w-[328px] h-[183px]"
            />
            <div className="sm:space-y-1 ">
              <div className="w-[328px] border bg-white dark:bg-white h-[40px] sm:h-[30px] border-[#BDBDBD] rounded-[4px] items-center   sm:mt-0 mt-6 grid place-content-center">
                <input
                  type="text"
                  placeholder=" Name of card "
                  className=" rounded-[4px]   outline-none text-[12px] w-[320px] dark:text-black bg-white placeholder:text-[16px] placeholder:font-semibold placeholder:text-black"
                />
              </div>
              <div className="w-[328px] border  h-[40px] sm:h-[30px] border-[#BDBDBD] rounded-[4px] items-center   sm:mt-0 mt-6 grid place-content-center">
                <input
                  type="text"
                  placeholder=" Card  number"
                  className=" rounded-[4px]   outline-none text-[12px] w-[320px] dark:text-black  bg-white   dark:bg-white placeholder:text-[16px] placeholder:font-semibold placeholder:text-black"
                />
              </div>
              <div className="w-[328px] border  h-[40px] sm:h-[30px] border-[#BDBDBD] rounded-[4px] items-center   sm:mt-0 mt-6 grid place-content-center">
                <input
                  type="text"
                  placeholder="Expiring date"
                  className=" rounded-[4px]   outline-none text-[12px] w-[320px] bg-white  dark:text-black dark:bg-white placeholder:text-[16px] placeholder:font-semibold placeholder:text-black"
                />
              </div>
              <div className=" border  h-[40px] sm:h-[30px] border-[#BDBDBD] rounded-[4px] items-center  w-[164px] sm:mt-0 mt-6 grid place-content-center">
                <input
                  type="text"
                  placeholder=" CVV/CVC"
                  className=" rounded-[4px]   outline-none text-[12px] w-[150px] dark:text-black bg-white  dark:bg-white placeholder:text-[16px] placeholder:font-semibold placeholder:text-black"
                /> 
              </div>
            </div>
          </div>
          <Link to="/settings/success">
            {" "}
            <button className=" bg-[#0049F5] sm:relative text-white  sm:w-60   w-80  p-2 sm:bottom-14 rounded-[27.34px] grid place-content-center sm:ml-[370px]  mt-[10px] m-7 sm:m-0 sm:mt-0 mb-3">
              Continue
            </button>
          </Link>
        </div>
      </div>
      <h3 className=" md:block hidden dark:text-black absolute text-[12px] text-[#878787] font-[900] mt-9  sm:left-[50%]  bottom-[70px] left-[40%]">
          Terms and conditions{" "}
      </h3>
      <Bottombar activeBar={'settings'} />
    </div>
  );
}

export default PaymentContMaterCard;
